import type { FaireProductEntity } from "../../entity_types/product";

export const p_arxz9a9msy: FaireProductEntity = {
  token: "p_arxz9a9msy",
  type: "product",
  name: "Kids Toddler Duck Camo Camouflage Snapback Hat",
  brandToken: "b_q75daxcrsn",
  brandName: "ThatsRad",
  imageUrl:
    "https://cdn.faire.com/fastly/6455494f804fe3559f947b25b0f5b123bc11813e12020253ba41bf35c8dad4c6.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description:
    "100% Polyester\n52-54 cm\naverage fit 2=7 years adjustable\nSnap Back Closure",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:03.947Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
